export const ADD_PURCHASE_ROWS_KEY = 'addPurchaseRows';

export const MONETATE_DECISIONS_URL = 'https://engine.monetate.net/api/engine/v1/decide/Waitrose';
export const MONETATE_REQUEST_METHOD = 'post';

export const MONETATE_OMNICHANNEL_JSON_ACTION_TYPE = 'monetate:action:OmnichannelJson';
export const MONETATE_EXPERIMENT_TYPE = 'monetateExperiment';
export const MONETATE_DEFAULT_VARIANT = 'default';
